<span [pTooltip]="getMessages()" [class.hide]="!formService.stateChangeAttempted || !control.invalid"
      class="pi pi-exclamation-circle error"></span>
